import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AdminPanel from './components/AdminPanel';
import Dashboard from './components/Dashboard';
import Navbar from './components/Navbar';
import OULinks from './components/OULinks';
import Zapros from "./components/Zapros";
import NotFound from "./components/NotFound";
import HomePage from "./components/HomePage"; // Добавляем новый компонент
import './styles.css';

const App = () => {
    const [role, setRole] = useState(localStorage.getItem('role') || '');

    const updateRole = (newRole) => {
        setRole(newRole);
        localStorage.setItem('role', newRole);
    };

    const logout = () => {
        setRole('');
        localStorage.removeItem('role');
    };

    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        if (storedRole) {
            setRole(storedRole);
        }
    }, []);

    return (
        <Router>
            <Navbar role={role} logout={logout} />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login setRole={updateRole} />} />
                <Route path="/dashboard" element={role ? <Dashboard /> : <Navigate to="/" />} />
                <Route path="/admin" element={role === 'admin' ? <AdminPanel /> : <Navigate to="/" />} />
                <Route path="/ou-links" element={role === 'admin' ? <OULinks /> : <Navigate to="/" />} />
                <Route path="/zapros" element={role === 'admin' ? <Zapros /> : <Navigate to="/" />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default App;